import Sticky from "sticky-js"

export function vanillaSticky() {
  var stickyHeader = new Sticky('#sticky-nav');

  jQuery(window).on('load scroll resize', function (){
  // Assign active class to nav links while scrolling
    var windowTop = jQuery(window).scrollTop();
    jQuery('.page-section, .wp-block-spacer').each(function (index, elem) {
      var offsetTop = jQuery(elem).offset().top;
      var outerHeight = jQuery(this).outerHeight(true);

      if( windowTop > (offsetTop - 100) && windowTop < ( offsetTop + outerHeight)) {
        var elemId = jQuery(elem).attr('id');
        if(elemId) {
          jQuery('#sticky-nav li.menu-item').removeClass('active');
          jQuery('#sticky-nav li.menu-item a[href="#'+ elemId +'"]').parents('li.menu-item').addClass('active');
        }
      }
    });
  });
}
